export enum SASTType {
  All = 'All',
  Bug = 'Bug',
  Vulnerability = 'Vulnerability',
}
